<template>
    <div id="page"/>
</template>

<script>

export default {
  data () {
    return {
      name: 'page'
    }
  }
}
</script>
<style lang="scss">
#page{
  margin-left: 200px;
  margin-right: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/g6/page.vue